<div class="row filter-collapse" #filterCollapse>
    <div class="col-12">
        <div class="row">
            <div class="form-group col-12 col-md-3">
                <label for="situacaoFilter" class="col-form-label">Situação</label>
                <select class="form-control" name="situacaoFilter" id="situacaoFilter" 
                    [ngModel]="filter.situacao || ''" (ngModelChange)="filter.situacao = $event ? $event : null; isFilterDirty = true"
                    #situacao="ngModel">
                    <option value="">Todas as situações</option>
                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                </select>                                       
            </div>
            <div class="form-group col-12 col-md">
                <label for="formaPagamentoFilter" class="col-form-label">Forma de Pagamento</label>
                <select class="form-control" name="formaPagamentoFilter" id="formaPagamentoFilter"
                    [ngModel]="filter.idFormaPagamento || ''" (ngModelChange)="filter.idFormaPagamento = $event ? $event : null; isFilterDirty = true"
                    #formaPagamentoFilter="ngModel">
                    <option value="">Todas as formas de pagamentos</option>
                    <option *ngFor="let formaPagamento of formasPagamentos" [ngValue]="formaPagamento.id">{{formaPagamento.nome}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12 col-sm">
                <label for="multiploFilter" class="col-form-label">Multiplo</label>
                <div class="input-group">
                    <input type="number" class="form-control" [(ngModel)]="filter.multiplo" (ngModelChange)="isFilterDirty = true" id="multiploFilter" name="multiploFilter">
                    <div class="input-group-append">
                        <span class="input-group-text">Dia(s)</span>
                    </div>                                
                </div>
            </div>
            <div class="form-group col-12 col-sm">
                <label for="prazoInicialFilter" class="col-form-label">Prazo Inicial</label>
                <div class="input-group">
                    <input type="number" class="form-control" [(ngModel)]="filter.prazoInicial" (ngModelChange)="isFilterDirty = true" id="prazoInicialFilter" name="prazoInicialFilter">
                    <div class="input-group-append">
                        <span class="input-group-text">Dia(s)</span>
                    </div>
                </div>
            </div>
            <div class="form-group col-12 col-sm">
                <label for="quantidadeParcelasFilter" class="col-form-label">Qtd. de Parcelas</label>
                <input type="number" class="form-control" [(ngModel)]="filter.quantidadeParcelas" (ngModelChange)="isFilterDirty = true" id="quantidadeParcelasFilter" name="quantidadeParcelasFilter">
            </div>
            <div class="form-group col-12 col-sm">
                <label for="prazoMedioFilter" class="col-form-label">Prazo Médio</label>
                <div class="input-group">
                    <input type="number" class="form-control" [(ngModel)]="filter.prazoMedio" (ngModelChange)="isFilterDirty = true" id="prazoMedioFilter" name="prazoMedioFilter">
                    <div class="input-group-append">
                        <span class="input-group-text">Dia(s)</span>
                    </div>
                </div>
            </div>                
        </div>              
    </div>
</div>